import { useQuery } from '@apollo/client/react';
import type { ErrorLike } from '@apollo/client';
import { GET_MANAGER } from './graphql/queries';
import type {
  E2nApiGetManagerQuery,
  E2nApiGetManagerQueryVariables,
  Manager,
} from '../gql/graphql';

export function useManager(): {
  manager: Manager | undefined;
  loading: boolean;
  error: string | ErrorLike | undefined;
} {
  const { data, loading, error } = useQuery<
    E2nApiGetManagerQuery,
    E2nApiGetManagerQueryVariables
  >(GET_MANAGER);

  if (data?.manager.__typename === 'ManagerError') {
    return { manager: undefined, loading, error: data.manager.message };
  }

  return { manager: data?.manager as Manager | undefined, loading, error };
}
